import { defineComponent as _defineComponent } from 'vue'
import VueQrcode from '@chenfengyuan/vue-qrcode'


export default /*#__PURE__*/_defineComponent({
  __name: 'QRCode',
  props: {
    text: null,
    size: { default: 256 },
    color: { default: '#000' },
    bgColor: { default: '#FFF' }
  },
  setup(__props: any) {



return { __sfc: true,VueQrcode }
}

})